import { commonProfHandler } from "./commonProfHandler";

export const caHandler = commonProfHandler({
  productCode: "CA",
  productName: "LOAN FOR CHARTERED ACCOUNTANTS",
});
